import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const MenuIcon = props => {
  const { className, rootClassName, extra } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return <svg
    className={classes}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 5.25V6.75H21V5.25H3ZM3 11.25V12.75H21V11.25H3ZM3 17.25V18.75H21V17.25H3Z" fill="#141414" />
  </svg>;
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;
